import type { ViewerContext } from '../../context/AuthContext'
import type { FindingStatus } from './findings'
import type { ReportStatus } from './reports'

type ViewerRole = ViewerContext['role']

export function canAccessReviewerWorkbench(role: ViewerRole): boolean {
  return role === 'Admin' || role === 'Reviewer'
}

export function canTransitionFindingStatus(role: ViewerRole, current: FindingStatus, next: FindingStatus): boolean {
  if (!canAccessReviewerWorkbench(role)) return false
  if (current !== 'draft') return false
  if (role !== 'Admin') return false
  return next === 'approved' || next === 'rejected'
}

export function canReleaseDraftReportFromWorkbench(role: ViewerRole, status: ReportStatus): boolean {
  if (!canAccessReviewerWorkbench(role)) return false
  if (role !== 'Admin') return false
  return status === 'draft'
}

/**
 * Generate CAPA from finding (#1855). Backend requireRole admin|editor|superadmin.
 * Workbench FE Admin maps those DB roles; reject findings cannot generate.
 */
export function canGenerateCapaFromFinding(role: ViewerRole, findingStatus: FindingStatus): boolean {
  if (!canAccessReviewerWorkbench(role)) return false
  if (role !== 'Admin') return false
  return findingStatus !== 'rejected'
}
